import React from 'react';
import { encodeForURI } from 'appSrc/utils';
import PropTypes from 'prop-types';
import FavoriteBadge from '../../FavoriteBadge';
import TextTruncate from 'react-text-truncate';
import { Link } from 'react-router-dom';
import {convertImage, DL_COLORS} from '../../../../utils';
import { getPrice } from '../../../../utils/format';
import styled, { css } from 'styled-components/macro';

const ElasticCard = ({
    buttonText,
    product,
    showFavorite,
    showTitle,
}) => {
    const { image: imgSrc, url, desireid, title, price } = product;
    const image = convertImage(imgSrc);

    return (
        <Wrapper>
            <Target to={url || `/app/products/${desireid}/${encodeForURI(title)}`}>
                <Container>
                    <ProductImage src={image} alt="" />
                    <Top>
                        <Price>${getPrice(price)}</Price>
                        {showFavorite && product && (
                            <Bookmark>
                                <FavoriteBadge
                                    className="favorite"
                                    type="product"
                                    item={product}
                                />
                            </Bookmark>
                        )}
                    </Top>
                    {buttonText && <ButtonWrap>
                        <Button>{buttonText}</Button>
                    </ButtonWrap>}
                </Container>
                {showTitle &&
                <ProductName>
                    <TextTruncate text={title} line={2} />
                </ProductName>}
            </Target>
        </Wrapper>
    );
};
ElasticCard.defaultProps = {
    buttonText: 'Purchase',
    product: {},
    className: '',
    style: {},
    showFavorite: false,
    showTitle: false,
};
ElasticCard.propTypes = {
    buttonText: PropTypes.string,
    product: PropTypes.object.isRequired,
    showFavorite: PropTypes.bool,
    showTitle: PropTypes.bool,
};

export default ElasticCard;

const Bookmark = styled.div`
    width: 1.2em;
    height: 1.2em;
    line-height: normal;
    margin: .5em;

    .favorite {
        height: 100%;
        width: 100%;
        line-height: normal;
    }
    [data-liked='true'] {
        color: var( --white );
    }
    [data-liked='false'] {
        color: var( --color-primary );

    ellipse {
        fill: #F8F8F8;
    }
`;
const Target = styled(Link)`
    &:active, &:link, &:visited, &:hover {
        text-decoration: none;
        color: var( --text-primary );
    }
`;
const Button = styled.div`
${() => css`
    background: ${DL_COLORS['gold']};
    opacity: 0.75;
    border-radius: 8px;
    color: white;
    font-size: .6316em;
    line-height: 125%;
    position: relative;
    text-transform: uppercase;
    width: auto;
    padding: .5em 1em;
    font-weight: 700;
    text-align: center;
    margin: 0 auto;
    display: table;
`}
`;
const ButtonWrap = styled.div`
${() => css`
    position: absolute;
    bottom: .6em;
    width: 100%;
    padding: 0 5px;
`}
`;
const Wrapper = styled.div`
${() => css`
    width: 100%;
`}
`;

const Container = styled.div`
${() => css`
    width: 100%;
    padding-bottom: 100%;
    position: relative;
    box-shadow: 0px 4px 4px rgba(0, 0, 0, 0.25);
    border-radius: 6px;
    overflow: hidden;
`}
`;
const ProductImage = styled.img`
    max-width: 100%;
    max-height: 100%;
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
`;
const Top = styled.div`
    top: 0;
    left: 0;
    display: flex;
    justify-content: space-between;
    position: absolute;
    width: 100%;
`;
const Price = styled.div`
    background: ${DL_COLORS['gold']};
    opacity: 0.75;
    border-radius: 8px;
    color: #F5F5F5;
    font-size: .8947em;
    font-weight: 900;
    line-height: 1em;
    margin: .5em;
    padding: .3em .3em .4em;
`;
const ProductName = styled.div`
    font-weight: 900;
    line-height: 115%;
    text-transform: uppercase;
    margin-top: .5em;
    font-size: .8947em;
    text-align: center;
`;
